<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../_common/date-select.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import dayjs from 'dayjs'
    import Zbutton from '../_common/z/zbutton.svelte'

    let schedulerComission = null

    onMount(async () => {
        schedulerComission = await window.flags('schedulerComission')
        if (!schedulerComission) schedulerComission = 'price'
        console.log('schedulerComission', schedulerComission)
    })

    function save() {
        window.flags('schedulerComission', false, schedulerComission)
        window.alert('configurações salvas')
    }

    let d = new Date()
    d.setHours(0, 0, 0, 0)
    let dates: { from: Date; to: Date } = window.api.utils.dates.currentMonth()
    function dateChanged(event) {
        dates = event.detail
    }

    async function recalculateComission() {
        if (dayjs(dates.to).diff(dates.from, 'days') > 31) {
            window.error(
                'O período máximo permitido é de 31 dias.\nCaso precise recalcular um período maior você deverá solicitar um período de até 31 dias de cada vez.',
            )
            return
        }
        if (!confirm('Deseja mesmo recalcular as comissões do período selecionado?')) {
            return
        }
        await window.api.schedulers.appointments.comissionsRecalculate({
            from: dates.from,
            to: dates.to,
            comissionSource: schedulerComission,
        })
        await window.api.pos.invoices.comissionsRecalculate({
            from: dates.from,
            to: dates.to,
        })
        window.alert('Solicitação enviada. O recálculo da comissão pode levar até 3 minutos.')
    }
</script>

<Zact>
    <div class="spacer" />
    <button class="btn btn-primary" on:click={() => save()}>Salvar</button>
</Zact>

<Zframe class="h-space" title="Configurações Gerais" headline="">
    <div class="grid-form">
        <div class="row">
            <div class="col limit-w_900">
                <div class="input-group">
                    <label for="" class="input-group-text">Base de cálculo para comissão do atendente</label>
                    <select class="form-select" bind:value={schedulerComission}>
                        <option value="price">Com base no valor de tabela do serviço</option>
                        <option value="pos">Com base na última venda feita ao cliente</option>
                    </select>
                </div>
            </div>
        </div>
        {#if schedulerComission === 'pos'}
            <div class="row">
                <div class="col text-muted">Caso não seja localizada uma compra feita pelo cliente será utilizado o valor de tabela do serviço.</div>
            </div>
        {/if}
    </div>
</Zframe>

<Zframe
    class="h-space"
    title="Recalcular comissão"
    headline="Recalcule comissões já lançadas no passado para refletir altrações recentes nos valores ou configurações desta tela"
>
    <div class="grid-form">
        <div class="row">
            <div class="col limit-w_900 d-flex gap-2">
                <DateSelect startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
                <Zbutton on:click={recalculateComission} label="Recalcular comissão"></Zbutton>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="text-muted">
                    Utilize o recálculo de comissões para fazer com que lançamentos anteriores reflitam alterações nas configurações de comissão do cadastro de
                    serviços.<br />
                    O recálculo de comissão não atualiza taxas de maquininhas caso estas sejam alteradas no cadastro de meios de pagamento.
                </div>
            </div>
        </div>
    </div>
</Zframe>
